import axios from 'axios';

import { GET_ITEM_TRANSACTIONS_DASHBOARD_DATA } from '../../modules/constants';

export function getItemTransactionsDashboardData(payload) {
  return {
    type: GET_ITEM_TRANSACTIONS_DASHBOARD_DATA,
    payload,
  };
}
